<template>
    <BlogLayout v-if="page" :tags="page.tags">
        <div class="card mb-4" v-if="page.publish_date">
            <div class="row d-block d-sm-none">
                <div class="text-center min-wp-100 col col-auto">
                    <div class="text-primary">
                        <span class="h2 fw-bold mb-2 fs-1">{{ page.publish_date.line_1 }}</span>
                        <p class="mb-2 text-uppercase">{{ page.publish_date.line_2 }}</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="text-center min-wp-100 col col-auto d-none d-sm-block">
                    <div class="text-primary">
                        <span class="h2 fw-bold mb-2 fs-1">{{ page.publish_date.line_1 }}</span>
                        <p class="mb-2 text-uppercase">{{ page.publish_date.line_2 }}</p>
                    </div>
                </div>
                <div class="col content mt-3 mt-sm-0">
                    <h1 class="mb-3">{{ page.name }}</h1>
                    <h3 v-if="page.author" class="fw-bold">
                        {{ $t('miscellaneous.by') }} {{ page.author }}
                    </h3>
                    <div class="pt-4 mt-3">
                        <div v-html="page.description"/>
                    </div>
                </div>
            </div>
        </div>
    </BlogLayout>
</template>

<script setup>
const page = useState('blogItem');
const error = useState('error');

gtm.openPage('blog_item');

if (error.value) {
    throw createError(error.value);
}

definePageMeta({
    middleware: ['page-blog'],
});
</script>
